import { render, staticRenderFns } from "./ContactsPage.vue?vue&type=template&id=efeb5c2c&scoped=true"
import script from "./ContactsPage.vue?vue&type=script&lang=js"
export * from "./ContactsPage.vue?vue&type=script&lang=js"
import style0 from "./ContactsPage.vue?vue&type=style&index=0&id=efeb5c2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efeb5c2c",
  null
  
)

export default component.exports